import React from 'react';

import HandyPageWrapper from '~Scenes/Handy/Components/HandyPageWrapper';
import StaffSettings from '~Scenes/Settings-v2/Scenes/StaffSettings';
import { useI18n } from '~Hooks';

/** Handheld shell around the shared Settings-v2 staff scene */
const Page = () => {
  const { i18n } = useI18n();

  return (
    <HandyPageWrapper pageTitle={i18n('Handy.Settings.StaffTitle')}>
      <StaffSettings isHandy />
    </HandyPageWrapper>
  );
};

export default Page;
